import React, { FC } from 'react'
import { Box, Typography } from 'transfix-ui/core'
import { makeStyles } from 'transfix-ui/core/styles'
import { POINT_RADIUS, POINT_DIAMETER } from 'apps/tms/constants'

interface ILegendItemProps {
  color: string
  text?: string
}

const useClasses = makeStyles(({ spacing }) => ({
  listMarker: {
    flexShrink: 0,
  },
  label: {
    marginLeft: spacing(1),
  },
}))

export const LegendItem: FC<ILegendItemProps> = ({ color, text = '' }) => {
  const classes = useClasses()

  return (
    <Box display='flex' alignItems='center'>
      <svg className={classes.listMarker} width={POINT_DIAMETER} height={POINT_DIAMETER}>
        <circle cx={POINT_RADIUS} cy={POINT_RADIUS} r={POINT_RADIUS} fill={color} />
      </svg>
      {text && (
        <Typography variant='caption' className={classes.label} color='textSecondary'>
          {text}
        </Typography>
      )}
    </Box>
  )
}
